import redirect from "./redirect";

export default [redirect];
